"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertyTypeSchema = void 0;
const slim_1 = require("@blockprotocol/type-system/slim");
const getPrimitiveSchema = ($ref) => ({
    $ref,
});
const getObjectSchema = (properties) => {
    const propertyList = {};
    const requiredArray = [];
    for (const { id, allowArrays, required } of properties) {
        const baseUrl = (0, slim_1.extractBaseUrl)(id);
        const propertyTypeReference = getPrimitiveSchema(id);
        if (allowArrays) {
            propertyList[baseUrl] = {
                type: "array",
                items: propertyTypeReference,
            };
        }
        else {
            propertyList[baseUrl] = propertyTypeReference;
        }
        if (required) {
            requiredArray.push(baseUrl);
        }
    }
    return {
        type: "object",
        properties: propertyList,
        required: requiredArray,
    };
};
const getArraySchema = (flattenedExpectedValues, { minItems, maxItems, infinity, itemIds }) => ({
    type: "array",
    items: {
        oneOf: itemIds.map((itemId) => 
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getExpectedValueSchemaById(itemId, flattenedExpectedValues)),
    },
    minItems,
    ...(!infinity ? { maxItems } : {}),
});
const getExpectedValueDataSchema = (data, flattenedExpectedValues) => {
    switch (data.typeId) {
        case "array":
            return getArraySchema(flattenedExpectedValues, data);
        case "object":
            return getObjectSchema(data.properties);
        default:
            return getPrimitiveSchema(data.typeId);
    }
};
const getExpectedValueSchemaById = (id, flattenedExpectedValues) => {
    const expectedValue = flattenedExpectedValues[id];
    if (!expectedValue) {
        throw new Error("Missing expected value");
    }
    const data = expectedValue.data;
    if (!data) {
        throw new Error("Missing expected value data");
    }
    return getExpectedValueDataSchema(data, flattenedExpectedValues);
};
const getPropertyTypeSchema = (data) => {
    if (!data.expectedValues.length) {
        throw new Error("Must have an expected value");
    }
    const oneOf = data.expectedValues.map((value) => {
        if (typeof value === "object") {
            return getExpectedValueSchemaById(value.id, data.flattenedCustomExpectedValueList);
        }
        return getPrimitiveSchema(value);
    });
    return {
        oneOf,
        description: data.description,
        title: data.name,
        kind: "propertyType",
    };
};
exports.getPropertyTypeSchema = getPropertyTypeSchema;
